import { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { FormRenderer } from "@/react/components/FormRendererV2/FormRenderer";
import type { FormEmbedDisplayFormat } from "@/react/types/Form";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { ThemeProvider } from "@circle-react/providers/Theme/ThemeProvider";
import "@circle-react-shared/uikit/TipTap/styles.scss";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import type { RenderType } from "@/react/components/FormRendererV2/contexts/FormRenderingContext";

const provider = new QueryClient();

interface FormsAppProps {
  embed_display_format?: FormEmbedDisplayFormat;
  id: number;
  index: number;
  is_preview?: boolean;
  is_used_on_pages?: boolean;
  popup_delay?: number;
  popup_frequency?: number;
  renderType?: RenderType;
}

export const FormsApp = ({
  id,
  index,
  is_preview = false,
  is_used_on_pages = false,
  embed_display_format,
  popup_frequency,
  popup_delay,
  renderType,
}: FormsAppProps) => (
  <StrictMode>
    <QueryClientProvider client={provider}>
      <Router>
        <ThemeProvider>
          <ToastProvider>
            <ModalManagerProvider>
              <FormRenderer
                id={id}
                index={index}
                isPreview={is_preview}
                isUsedOnPages={is_used_on_pages}
                embedDisplayFormat={embed_display_format}
                popupFrequency={popup_frequency}
                popupDelay={popup_delay}
                renderType={renderType}
              />
            </ModalManagerProvider>
          </ToastProvider>
        </ThemeProvider>
      </Router>
    </QueryClientProvider>
  </StrictMode>
);
